(function ($) {
 	$.fn.capitechSettings = function() {
		var $settingsForm = $(this);
		
		function fillFormItems() {
			var appSettingsObj = _appSettingsObj;
			
			if (_appSettingsObj) {
				$.each(appSettingsObj, function(key, value) {
					$('#' + key).val(value);
				});
			}
		}
		fillFormItems();
		
		// Submit event
		$(this).on('submit', function(evt) {
			evt.preventDefault();
			saveSettings();
		});
		
		function saveSettings(evt, username, password) {
			var appSettingsObj = {};
			
			// Loop form items
			$settingsForm.find('input.form-control, select.form-control').each(function(index, obj) {
				var $objKey = $(obj);
				appSettingsObj[$objKey.attr('name')] = $objKey.val()
			});
			setLocalStorage('myCapitechSettings', appSettingsObj);
			location.reload();
		}
		return;
	};
}(jQuery));